import { Compass, RefreshCcw, ShieldCheck } from "lucide-react";
import { Overline, Reveal } from "./Reveal";
import { WHATSAPP_URL, trackClick } from "../../lib/site";

const PILLARS = [
  {
    num: "01",
    icon: Compass,
    title: "Compreender o contexto, não apenas o sintoma",
    text: "Ansiedade, exaustão, conflitos e dificuldades de adaptação têm uma história. Antes de buscar soluções, procuramos entender como esse sofrimento se construiu — e o que o mantém.",
    span: "md:col-span-4",
  },
  {
    num: "02",
    icon: RefreshCcw,
    title: "Identificar padrões e construir novas possibilidades",
    text: "Exploramos formas de comunicação, papéis familiares e padrões de relacionamento que podem estar contribuindo para o sofrimento, favorecendo mudanças mais conscientes e saudáveis.",
    span: "md:col-span-4",
  },
  {
    num: "03",
    icon: ShieldCheck,
    title: "Fortalecer recursos para enfrentar os desafios da vida",
    text: "A terapia busca desenvolver autonomia, flexibilidade emocional e relações mais equilibradas, para que você possa lidar com seus desafios de forma mais leve e segura — seja diante da rotina, dos relacionamentos ou de uma condição de saúde.",
    span: "md:col-span-4",
  },
];

export const Pillars = () => (
  <section
    id="pilares"
    data-testid="pillars-section"
    className="bg-bone/60 py-24 lg:py-32"
  >
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <Reveal>
        <Overline>Como eu trabalho</Overline>
        <h2 className="mt-6 max-w-2xl font-serif text-3xl font-normal leading-tight tracking-tight text-bark sm:text-4xl lg:text-5xl">
          Os pilares do meu trabalho
        </h2>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-12">
        {PILLARS.map((pillar, i) => (
          <Reveal key={pillar.num} delay={i * 0.1} className={pillar.span}>
            <article
              data-testid={`pillar-card-${pillar.num}`}
              className="group flex h-full flex-col justify-between rounded-2xl bg-sand p-10 shadow-[0_8px_30px_rgba(0,0,0,0.04)] transition-[transform,box-shadow] duration-500 hover:-translate-y-1.5 hover:shadow-[0_24px_48px_rgba(45,51,47,0.1)] lg:p-12"
            >
              <div>
                <pillar.icon
                  className="h-8 w-8 text-copper transition-transform duration-500 group-hover:-rotate-6"
                  strokeWidth={1.4}
                />
                <h3 className="mt-8 font-serif text-2xl font-medium leading-snug text-bark sm:text-3xl">
                  {pillar.title}
                </h3>
                <p className="mt-5 text-base leading-relaxed text-moss">
                  {pillar.text}
                </p>
              </div>
            </article>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.15}>
        <div className="mt-14 text-center">
          <a
            data-testid="pillars-cta"
            href={WHATSAPP_URL}
            onClick={() => trackClick("pilares")}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 rounded-full bg-brand px-8 py-4 text-sm font-semibold text-sand shadow-[0_16px_36px_rgba(58,77,57,0.28)] transition-[background-color,transform,box-shadow] duration-300 hover:-translate-y-1 hover:bg-brand-deep"
          >
            Quero conversar sobre meu caso
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);
